/*-----------------------------------------------------------------------------------------------

  Permission for Vue Navigation Guard

-----------------------------------------------------------------------------------------------*/

import router from './router'
import store, { LoadInitialData } from './store'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getAccessToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  if (to.path == '/500') {
    next()
    return
  }

  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  let hasToken = getAccessToken()

  if (!hasToken) {
    const tokenRefreshed = await store.dispatch('user/refreshToken')
    if (tokenRefreshed) {
      hasToken = getAccessToken()
    }
  }

  // Periksa apakah sudah ada token pada client
  if (hasToken) {
    // Jika sudah memiliki token:

    if (to.path === '/login') {
      console.log('To Login')
      // Jika yang diakses adalah halaman login, teruskan ke halaman redirectnya atau awal
      const nextPath = to.query.r
      next({ path: nextPath || '/' })
      NProgress.done()
    } else {
      // Memeriksa sesi apakah sudah memiliki role untuk mengakses path tujuan
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        next()
      } else {
        // Jika pada aplikasi client belum ada rule yang disimpan,
        try {
          // ambil informasi rule sesuai dengan user yang aktif pada aplikasi
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          const { roles } = await store.dispatch('user/getInfo')

          // Load vuex initial data
          await LoadInitialData()

          // generate accessible routes map based on roles
          // Membuat peta rute yang dapat diakses berdasarkan role pengguna
          const accessRoutes = await store.dispatch(
            'permission/generateRoutes',
            roles
          )

          // dynamically add accessible routes
          router.addRoutes(accessRoutes)

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          // eslint-disable-next-line
          next({ ...to, replace: true })
        } catch (error) {
          // remove token and go to login page to re-login
          // await store.dispatch('user/resetToken')
          // // Message.error(error || 'Has Error')
          // console.log(to.path)
          // next(`/login?r=${to.path}`)
          next(`/500?r=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
